export enum EvaluationStatesEnum {
  inProcess = 0,
  onCheck = 1,
  onPreview = 2,
}
